import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { BBResponseContainer } from "../carrier/response-container";
import { timeout, tap } from 'rxjs/operators';
import { WorkListRequest } from './work-list-request';
import { ModifiedSample } from './model/modified-sample';
import { LabMDM } from '../masterdata/models/lab';
import { NextStepProcessRequest } from './model/next-step-process-request';
import { PreparePlatesRequest } from './model/prepare-plates-request';

@Injectable()
export class WorkListService {

  readonly CARRIER_STATE_MDM_SERVICE = 'admin/mdm/carrier/state';

  constructor(private http: HttpClient) {
  }

  //Gets a list of process Steps for selected Lab
  getProcessStepsByLab(lab:LabMDM, active: boolean): Observable<BBResponseContainer> {
    let url = environment.BB_MDMSERVICE_URL + this.CARRIER_STATE_MDM_SERVICE;
    let requestParam = new HttpParams().set('labId', lab._id).set('active', active.toString());
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
    }));
  }

  // get Samples For ProcessStep
  getSamplesForProcessStep(processStepName: string): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_LIB_PREP_URL + 'processstep/samples';
    let requestParam = new HttpParams()
    .set('processStepName', processStepName);
    const options = url ? { params: requestParam } : {};

    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }

  // save the work list
  saveWorkList(workListRequest: WorkListRequest): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_LIB_PREP_URL + 'processstep/worklist';
    return this.http.post<BBResponseContainer>(url, workListRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  //Get the work list for selected process step
  getWorkListForCurrentProcessStep(processStepName: string): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_LIB_PREP_URL + 'processstep/worklist';
    let requestParam = new HttpParams()
    .set('processStepName', processStepName);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  //Update samples data with updated worklist
  insertOrRemoveSamplesInWorkList(modifiedSampleList: ModifiedSample[]): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_LIB_PREP_URL + 'processstep/worklist/sample';
    return this.http.post<BBResponseContainer>(url, modifiedSampleList).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  //Move Samples to next Step
  moveSamplesToNextStep(nextStepProcessRequest: NextStepProcessRequest): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_LIB_PREP_URL + 'worklist/nextstep';
    return this.http.put<BBResponseContainer>(url, nextStepProcessRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  //Prepare plates for Samples
  preparePlatesForSamples(preparePlatesRequest: PreparePlatesRequest): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_LIB_PREP_URL + 'worklist/plates';
    return this.http.put<BBResponseContainer>(url, preparePlatesRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  getPlateAndPlateFirstEmptyColumn(workListId: string): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_LIB_PREP_URL + 'worklist/plates';
    let requestParam = new HttpParams().set('workListId', workListId);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  // delete the work list
  deleteWorkList(workListId: string): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_LIB_PREP_URL + 'worklist/delete';
    return this.http.put<BBResponseContainer>(url, workListId).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  getPlateViewDetails(plateBarcode: string): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_LIB_PREP_URL + 'worklist/plate';
    let requestParam = new HttpParams().set('plateBarcode', plateBarcode);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }
}
